import React from 'react';
import { Grid } from '@mui/material';

import img_01 from '../data/images/image_3d_01.png';

type Props = {}

const TeamProgram = (props: Props) => {
    return (
        <>
            <Grid container spacing={2} sx={{ mt: 5, p: 20 }}>
                {/* <img src={img_01} /> */}
            </Grid>
        </>
    )
}

export default TeamProgram